import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';

interface OTPInputProps {
  length: number; // Number of digits
  onChange: (otp: string) => void; // Callback for when OTP changes
  containerStyle?: React.CSSProperties; // Optional custom styles for container
  inputStyle?: React.CSSProperties; // Optional custom styles for input fields
}

const OTPInput: React.FC<OTPInputProps> = ({
  length,
  onChange,
  containerStyle,
  inputStyle,
}) => {
  const [otp, setOtp] = useState<string[]>(Array(length).fill(''));

  const handleChange = (value: string, index: number): void => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      onChange(newOtp.join(''));

      // Move to the next input field if the current one is filled
      if (value && index < length - 1) {
        const nextInput = document.getElementById(
          `otp-${index + 1}`,
        ) as HTMLInputElement;
        nextInput?.focus();
      }
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ): void => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      // Move to the previous input field on backspace
      const prevInput = document.getElementById(
        `otp-${index - 1}`,
      ) as HTMLInputElement;
      prevInput?.focus();
    }
  };

  return (
    <Box display="flex" gap={1} style={containerStyle}>
      {otp.map((digit, index) => (
        <TextField
          key={index}
          id={`otp-${index}`}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
            handleKeyDown(e, index)
          }
          slotProps={{
            input: {
              style: {
                textAlign: 'center',
                fontSize: '16px',
                width: '40px',
                height: '40px',
                ...inputStyle,
              },
            },
          }}
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
            },
          }}
        />
      ))}
    </Box>
  );
};

export default OTPInput;